import React from 'react';
import { Link } from 'react-router-dom';
import Panel from '../../components/ui/Panel';
import Button from '../../components/ui/Button';

const ImplementationPage: React.FC = () => {
  return (
    <div>
      <h1 id="overview" className="text-3xl text-osrs-gold font-bold uppercase mb-4">Implementation</h1>
      <p className="text-osrs-yellow mb-8">
        The package is React. One stylesheet makes the components look like the interface without a Tailwind setup. Tailwind remains available when you want the colour utilities in your own markup.
      </p>

      <section id="getting-started" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Getting Started</h2>
        <Panel>
          <pre className="bg-osrs-black p-4 text-osrs-yellow overflow-x-auto mb-4">npm install github:t8or/osrs-design-system</pre>
          <p className="text-osrs-yellow">
            Peer dependencies are react and react-dom 18 or newer. The registry publish of the package name is a maintainer step. The Git install is the path that works today. See <Link className="text-osrs-gold" to="/resources/downloads">Downloads</Link>.
          </p>
        </Panel>
      </section>

      <section id="react" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">React</h2>
        <Panel>
          <pre className="bg-osrs-black p-4 text-osrs-yellow overflow-x-auto mb-4">{`import 'osrs-design-system/styles.css';
import { Button, Panel, Input, Inventory } from 'osrs-design-system';

export function Bank() {
  return (
    <Panel title="Bank of Gielinor">
      <Input label="Search" />
      <Inventory items={[]} />
      <Button>Deposit inventory</Button>
    </Panel>
  );
}`}</pre>
          <Button>Deposit inventory</Button>
        </Panel>
      </section>

      <section id="tailwind" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Tailwind</h2>
        <Panel>
          <p className="text-osrs-yellow mb-4">
            Optional. Use it when your own markup needs the osrs colour utilities. Components do not require it.
          </p>
          <pre className="bg-osrs-black p-4 text-osrs-yellow overflow-x-auto">{`const osrsPreset = require('osrs-design-system/tailwind-preset');

module.exports = {
  presets: [osrsPreset],
  content: ['./src/**/*.{js,jsx,ts,tsx}'],
};`}</pre>
        </Panel>
      </section>

      <section id="styling" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Styling</h2>
        <Panel>
          <ul className="list-disc list-inside text-osrs-yellow space-y-2 ml-4">
            <li>Import styles.css once, at the root of the app.</li>
            <li>Raised surfaces use the bevel. Inset surfaces use the inverted bevel.</li>
            <li>Leave corner radius at zero on game chrome.</li>
          </ul>
        </Panel>
      </section>

      <section id="best-practices" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Best Practices</h2>
        <Panel>
          <ul className="list-disc list-inside text-osrs-yellow space-y-2 ml-4">
            <li>Import components from osrs-design-system. Do not copy the class strings out of the docs.</li>
            <li>This package is React. It does not ship Vue, Angular, or a plain CSS component set.</li>
            <li>Keep item art outside the package and pass it into InventorySlot.</li>
          </ul>
        </Panel>
      </section>
    </div>
  );
};

export default ImplementationPage;
